import { enqueueSnackbar, UploadFile, DownloadFile } from 'actions';

import {
	ConfigurationNokiaExportRequest,
	ConfigurationHuaweiExportRequest,
	GetLastDumpsUpdateRequest
} from '../requests/ConfigurationRequests';

export const SET_FORM_STATE = 'SET_FORM_STATE';
export const GET_DUMPS_UPDATE = 'GET_DUMPS_UPDATE';

const onSetFormState = (value) => ({
	type: SET_FORM_STATE,
	formState: value
});

const onLastDumpsUpdate = (dumpsUpdate) => ({
	type: GET_DUMPS_UPDATE,
	dumpsUpdate
});

export const LastDumpsUpdate = () => async (dispatch) => {
	await GetLastDumpsUpdateRequest().then(response => {
		dispatch(onLastDumpsUpdate(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const ProcessNokiaFile = (values) => async (dispatch) => {
	await ConfigurationNokiaExportRequest(values).then(response => {
		dispatch(DownloadFile(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const ProcessHuaweiFile = (values) => async (dispatch) => {
	await ConfigurationHuaweiExportRequest(values).then(response => {
		dispatch(DownloadFile(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const ConfigurationNokiaExport = (values) => async (dispatch) => {
	if (values.inputType === 'file' && !values.allSites) {
		await UploadFile(values.sites).then(response => {
			const newValues = { ...values, sites: response.data };
			dispatch(ProcessNokiaFile(newValues));
		}).catch((error) => {
			if (error) {
				dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
			}
		});
	} else {
		await ConfigurationNokiaExportRequest(values).then(response => {
			dispatch(DownloadFile(response.data));
		}).catch((error) => {
			if (error) {
				dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
			}
		});
	}
};

export const ConfigurationHuaweiExport = (values) => async (dispatch) => {
	if (values.inputType === 'file') {
		await UploadFile(values.sites).then(response => {
			const newValues = { ...values, sites: response.data };
			dispatch(ProcessHuaweiFile(newValues));
		}).catch((error) => {
			if (error) {
				dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
			}
		});
	} else {
		await ConfigurationHuaweiExportRequest(values).then(response => {
			dispatch(DownloadFile(response.data));
		}).catch((error) => {
			if (error) {
				dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
			}
		});
	}
};

export const SetFormState = (value) => (dispatch) => {
	dispatch(onSetFormState(value));
};
